import React from "react";
import { Twitter } from "../../Svgs/SocialIcons/twitter";
import { Facebook } from "../../Svgs/SocialIcons/facebook";
import { LinkedIn } from "../../Svgs/SocialIcons/linkedin";
import { WhatsApp } from "../../Svgs/SocialIcons/whatsapp";
import { Email } from "../../Svgs/SocialIcons/email";
import { CopyLink } from "../../Svgs/SocialIcons/copyLink";

const getSocialIcons = (color, iconType) => {
  switch (iconType) {
    case "plain-color-svg":
      return {
        facebook: <Facebook key={iconType} />,
        twitter: <Twitter key={iconType} />,
        linkedin: <LinkedIn key={iconType} />,
        whatsapp: <WhatsApp key={iconType} />,
        email: <Email key={iconType} />,
        copylink: <CopyLink key={iconType} />,
      };

    default:
      return {
        facebook: <Facebook color={color} key={iconType} />,
        twitter: <Twitter color={color} key={iconType} />,
        linkedin: <LinkedIn color={color} key={iconType} />,
        whatsapp: <WhatsApp color={color} key={iconType} />,
      };
  }
};

export const socialShareData = ({ fbUrl, twitterUrl, linkedinUrl, whatsappUrl, mailtoUrl, iconColor, iconType }) => {
  const socialIcons = getSocialIcons(iconColor, iconType);
  const getOptions = () => {
    return [
      {
        name: "facebook",
        url: fbUrl,
        icon: socialIcons.facebook,
        text: "Facebook",
        bgColor: "#3C5B97",
        alt: "fb icon",
      },
      {
        name: "twitter",
        url: twitterUrl,
        icon: socialIcons.twitter,
        text: "Twitter",
        bgColor: "#000000",
        alt: "twitter icon",
      },
      {
        name: "linkedin",
        url: linkedinUrl,
        icon: socialIcons.linkedin,
        text: "LinkedIn",
        bgColor: "#0078B6",
        alt: "linkedin icon",
      },
      {
        name: "whatsapp",
        url: whatsappUrl,
        icon: socialIcons.whatsapp,
        text: "Whatsapp",
        bgColor: "#28D068",
        alt: "whatsapp share",
      },
      {
        name: "email",
        url: mailtoUrl,
        icon: socialIcons.email,
        text: "Email",
        bgColor: "#D85B5B",
        alt: "email share",
      },
      {
        name: "copy",
        url: "null",
        icon: socialIcons.copylink,
        text: "Copy Link",
        bgColor: "#00000014",
        alt: "copy link and share",
      },
    ];
  };
  return getOptions();
};
